import { Color } from '@diritto/common/style/color';
import { InfoFilledIcon } from 'icons/InfoFilledIcon';
import React from 'react';

export const DescriptionBlock = ({
  message,
  className = '',
  bgColor = Color.Gray200,
  color = Color.Black,
  isBorderRadius = true,
  icon,
  rightIcon,
}: {
  message: string | React.ReactNode;
  className?: string;
  bgColor?: string;
  color?: string;
  isBorderRadius?: boolean;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}) => (
  <div
    className={`flex justify-between items-start gap-2 w-full p-4 font-medium text-xxs ${
      isBorderRadius ? 'rounded-md' : ''
    } ${className}`}
    style={{
      backgroundColor: bgColor,
      color,
    }}>
    <div className="flex items-center justify-center gap-1 flex-none h-5">
      {icon ?? <InfoFilledIcon color={Color.Gray600} className="w-4 h-4" />}
    </div>
    <div className="flex-grow whitespace-pre-wrap">{message}</div>
    {rightIcon && <div className="flex items-center justify-center gap-1 flex-none h-5">{rightIcon}</div>}
  </div>
);
